import * as React from "react";
import { useRef, useState, useEffect } from "react";
import "./PinForm.css";

interface IProps {
    OnPinChange: (pin: string) => void;
    Label?: string;
    ValidationState?: () => "success" | "warning" | "error" | undefined;
    ErrorBlock?: string;
    Value?: string;
}

export const PinForm = ({ OnPinChange, Label, ValidationState, ErrorBlock, Value }: IProps) => {
    const refs = useRef<Array<(HTMLInputElement | null)>>([]);
    const [code, setCode] = useState({ "0": "", "1": "", "2": "", "3": "" });

    useEffect(() => {
        if (Value) {
            const valArr = Value.split("");
            const newCode = code;
            valArr.forEach((item, index) => {
                newCode[`${index}`] = item
            })
            setCode(newCode);
        }
    }, [Value]);

    const RenderErrorBlock = () => {
        if (!ErrorBlock || !ValidationState || (ValidationState && ValidationState() !== "error")) {
            return <span className="pin-container__error-block" />;
        }
        return <span className="pin-container__error-block">{ErrorBlock}</span>;
    }

    const OnKeyDown = (field: number, ev: React.KeyboardEvent<HTMLInputElement>) => {
        let ref = refs.current[field];
        if (ev.key === "Backspace" && ref) {
            let newCode = { ...code, [`${field}`]: "" };
            setCode(newCode)
            OnPinChange(`${newCode['0']}${newCode['1']}${newCode['2']}${newCode['3']}`);
            if (field > 0 && ref.value === "") {
                SetFocusToInput(field - 1);
            }
        } else if (ev.key === "Tab") {
            if (field === 3) {
                SetFocusToInput(0);
            }
        }
    }

    const OnChange = (field: number, ev: any) => {
        let value: string = ev.target.value;
        value = value.trim();
        if (value.length === 0 || isNaN(+value)) {
            return;
        }
        value = value.charAt(value.length - 1);
        if (value) {
            let newCode = { ...code, [field]: value };
            setCode(newCode)
            OnPinChange(`${newCode['0']}${newCode['1']}${newCode['2']}${newCode['3']}`);
            if (field < 3) {
                SetFocusToInput(field + 1);
            }
        }
    }

    const SetFocusToInput = (field: number) => {
        let ref = refs.current[field];
        if (ref !== null) {
            ref.focus();
        }
    }

    const OnFocus = (event) => {
        event.target.select();
    }

    return (
        <div className="pin-container">
            <div className="pin-label-wrapper">
                <div className="pin-container__label">
                    <p>{Label}</p>
                </div>
                <form autoComplete="off" className="pin-container__inputs">
                    <input type="hidden" value="something" />
                    {
                        Array.from(Array(4).keys()).map(item => {
                            return (
                                <input
                                    key={item}
                                    ref={ref => refs.current[item] = ref}
                                    type="password"
                                    tabIndex={item}
                                    className={`pin-input ${ValidationState && ValidationState() === "error" ? "pin-input--error" : ""} ${code[`${item}`].length > 0 ? "pin-input-dot" : ""}`}
                                    name={`c${item}`}
                                    autoComplete="none"
                                    onFocus={OnFocus}
                                    onChange={OnChange.bind(event, item)}
                                    onKeyDown={OnKeyDown.bind(event, item)}
                                    value={code[`${item}`]} />
                            )

                        })
                    }
                </form>
            </div>
            {RenderErrorBlock()}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/controls/Form/PinForm.tsx